export default "__VITE_ASSET__D181kkZS__"